import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

import arrowLeft from '@/assets/icons/arrow-left.svg'
import arrowRight from '@/assets/icons/arrow-right.svg'
export const TabContentWrapper = styled(FocusNode)``

export const TabsElem = styled(FocusNode)`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  height: 72px;
  overflow: hidden;
`

export const TabElem = styled(FocusNode)<{
  $activeTab: boolean
}>`
  position: relative;
  display: flex;
  min-width: 198px;
  padding: 0 15px;
  justify-content: center;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 68px;
  height: 72px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.tabs.text};
  white-space: nowrap;
  box-shadow: none;
  cursor: pointer;
  background-color: ${({ $activeTab, theme }) =>
    $activeTab ? theme.colors.tabs.activeElem.background : 'transparent'};
  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px;
    width: 100%;
    background-color: ${({ $activeTab, theme }) =>
      $activeTab ? theme.colors.tabs.activeElem.border : 'transparent'};
  }
  &.isFocusedLeaf {
    opacity: 1;
    background-color: ${(props) =>
      props.theme.colors.tabs.focusedElem.background};
    &:after {
      background-color: ${(props) =>
        props.theme.colors.tabs.focusedElem.border};
    }
  }
`

export const NavigationSection = styled.div<{
  $isVisible?: boolean
}>`
  position: absolute;
  top: 0;
  height: calc(100% - 4px);
  width: 50px;
  background-repeat: no-repeat;
  background-size: 40px 40px, 100%;
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  transition: opacity 0.3s;
  z-index: 1;
  cursor: pointer;
`
export const PrevNavigationSection = styled(NavigationSection)`
  left: 0;
  background-position: 0% 50%, 0 0;
  background-image: url(\"${arrowLeft}\"),
    linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.3) 30%,
      rgba(0, 0, 0, 0.6) 100%
    );
`
export const NextNavigationSection = styled(NavigationSection)`
  right: 0;
  background-position: 100% 50%, 0 0;
  background-image: url(\"${arrowRight}\"),
    linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.3) 30%,
      rgba(0, 0, 0, 0.6) 100%
    );
`

export const TabsElemWrapper = styled.div<{
  $showPrevNavigation: boolean
  $showNextNavigation: boolean
}>`
  display: block;
  position: relative;
  margin-bottom: 50px;
  margin-right: 112px;
  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background-color: ${(props) => props.theme.colors.tabs.separator};
  }

  ${PrevNavigationSection}, ${NextNavigationSection} {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s;
  }

  ${({ $showPrevNavigation }) =>
    $showPrevNavigation &&
    css`
      &:hover ${PrevNavigationSection} {
        opacity: 1;
        pointer-events: auto;
      }
    `}

  ${({ $showNextNavigation }) =>
    $showNextNavigation &&
    css`
      &:hover ${NextNavigationSection} {
        opacity: 1;
        pointer-events: auto;
      }
    `}
`
